module.exports = 'ttb.dashboard.completedTasksAndBugs.component';

angular.module(module.exports, [])
    .component('completedTasksAndBugs', {
        template: `<div ng-cloak class="widget-simple-chart text-right card-box">
                       <div class="circliful-chart remaining-days" circliful circliful-percent="$ctrl.data.passedPercents"
                        circliful-fg-color="#5cb85c" circliful-bg-color="#ebeff2"></div>
                       <h3 class ="text-success" ng-if="!$ctrl.loading"><span title="{{ 'DashBoard_Burnder_Hours' | translate}}">{{$ctrl.data.burned}}</span>/<span title="{{ 'DashBoard_Effective_Total_Hours' | translate}}">{{$ctrl.data.effectveTotal}}</span></h3>
                       <h3 class ="text-success" ng-if="$ctrl.loading" translate>Loading</h3>
                       <p class="text-muted text-nowrap" translate>DashBoard_Burned_Hours</p>   
                       <p class="text-muted text-nowrap" title="{{ 'DashBoard_Planned_Total_Explanation' | translate}}">{{ 'DashBoard_Estimated_Hours' | translate}} {{$ctrl.data.plannedTotal}}</p>   
                   </div>`,
        controller: CompletedTasksAndBugs,
        bindings: {
            team: '<'
        }
    });

function CompletedTasksAndBugs($http, completedTasksAndBugsUrl) {
    this.$onChanges = (changes) => {
        if (changes.team) {
            if (changes.team.currentValue !== undefined) {
                this.load(changes.team.currentValue);
            }
            else {
                this.update({ passedPercents: 0, burned: 0, effectveTotal: 0 });
            }
        }
    }

    this.update = (data) => {
        this.data = data;
        //this.info = `${data.burned}/<span title="Effective Hours. It is sum of real spent time for completed items and estimations for uncomplited">${data.effectveTotal}</span> (<span title="Planned Hours.">${data.plannedTotal}</span>)`;
    }

    this.load = (team) => {
        this.loading = true;
        this.info = 'loading...';

        $http.get(completedTasksAndBugsUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    this.loading = false;
                    this.update(response.data);
                },
                () => {
                    this.loading = false;
                });
    }
}
CompletedTasksAndBugs.$inject = ['$http', 'completedTasksAndBugsUrl'];


// WEBPACK FOOTER //
// ./components/completed-tasks-and-bugs/completed-tasks-and-bugs.component.js